// @flow
import React from 'react';
import styled from 'styled-components';
import { Button, Text } from 'bench-internal-theme';
import { Modal } from 'modal-components';
import { ButtonLayout } from './ApplyConfirmationModal.styles';

type ApplyConfirmationModalProps = {
  closeModal: () => void;
  description?: string;
  onConfirm: () => void;
  title: string;
};

const ApplyConfirmationModal = ({
  closeModal,
  onConfirm,
  title,
  description,
}: ApplyConfirmationModalProps) => (
  <Modal>
    <Modal.Header title={title} onClose={closeModal} />
    <Modal.Body>
      {description && <Text>{description}</Text>}
      <ButtonLayout>
        <Button onClick={closeModal} styleType="ghost">
          Cancel
        </Button>
        <Button
          onClick={() => {
            closeModal();
            return onConfirm();
          }}
          aria-label="Confirm"
          styleType="primary"
          type="submit"
        >
          Confirm
        </Button>
      </ButtonLayout>
    </Modal.Body>
  </Modal>
);

ApplyConfirmationModal.defaultProps = {
  description: undefined,
};

export default ApplyConfirmationModal;
